<template>
    <div class="anim-entrada">

        <div class="form" v-if="!loading" style="margin-inline: -10px;">
            <!-- <p>{{ this.$store.state.deliveryEndereco }}</p> -->
            <div v-if="aceitaEntrega && aceitaRetirada && !modoBalcao" style="display: flex; gap: 4px; margin-bottom: 12px;">
                <button
                    :class="!retirarNoLocal ? 'btn-entregar-retirar-selecionado' : 'btn-entregar-retirar'"
                    @click="selecionarEntregaNoLocal(false)"
                >Entrega</button>
                <button
                    :class="retirarNoLocal ? 'btn-entregar-retirar-selecionado' : 'btn-entregar-retirar'"
                    @click="selecionarEntregaNoLocal(true)"
                >Retirar no local</button>
            </div>

            <div v-if="!retirarNoLocal && !modoBalcao" class="input-btn">
                <p style="margin-bottom: 5px;">CEP</p>
                <!-- <p>{{ this.$store.state.nomeCliente }}</p>
                <p>{{ this.$store.state.cpfCliente }}</p> -->
                <!-- <h1>{{ this.exigirNome }}</h1> -->
                <div>
                    <input type="text" id="cp" v-model="cep" @input="cep=cep.replace(/\D/g, '')" @keyup.enter="enviarCep">
                    <button class="btn-normal" v-if="!loading" @click="enviarCep">Buscar CEP</button>
                    <img v-if="loading" src="../../assets/loading.gif" alt="" style="height: 35px" >
                </div>
            </div>

            <div v-if="this.cepNaoEncontrado">
                <p style="margin-top: 25px;">O CEP digitado não foi encontrado. Por favor, entre com seu endereço completo nos campos abaixo.</p>
            </div>
            <div v-if="exigirNome">
                <p class="input-label">Seu nome</p>
                <input type="text" id="nome" v-model="nome" >

                <p class="input-label">Seu cpf</p>
                <input type="text" id="cpf" v-model="cpf" >
            </div>

            <div v-if="!modoBalcao && !retirarNoLocal">
                <p class="input-label">Rua</p>
                <input type="text" id="logradouro" v-model="rua" >

                <p class="input-label">Número</p>
                <input type="number" id="numero" v-model="numero">

                <p class="input-label">Complemento</p>
                <input type="text" id="complemento" v-model="complemento" placeholder="Caso necessário">

                <p class="input-label">Bairro</p>
                <bairros-autocomplete :listaCompleta="bairrosAllFood" @onSelect="this.escolheuBairro" @validou="this.validouBairro" :bairroDoViaCep="this.bairroDoViaCep"/>

                <p class="input-label">Cidade</p>
                <input type="text" id="cidade" v-model="cidade" >

                <p class="input-label">Estado</p>
                <input type="text" id="uf" v-model="uf" >
            </div>

            <button v-if="!validou" class="btn-normal" style="margin-top: 35px; background: grey" @click="salvar" >Enviar</button>
            <button v-if="validou" class="btn-normal" style="margin-top: 35px;" @click="salvar">Enviar</button>
        </div>

        <div v-if="loading" class="form-outline center" style="height: 300px; max-width: 100%;">
            <img src="../../assets/loading.gif" alt="" style="height: 50px" />
        </div>
    </div>
</template>

<script>
import { validate as validadeCpf } from 'gerador-validador-cpf'
import ApiDelivery from '@/api/ApisDelivery'
import EnderecoModel from '@/model/enderecoModel'
import Swal from 'sweetalert2'
import BairrosAutocomplete from './BairrosAutocomplete.vue'

export default {
    components: { BairrosAutocomplete },

    name: "DadosEndereco",

    props: {
        exigirNome: Boolean,
        idCliente: Number,
        telefoneCliente: String,
        usarEnderecoAntigo: Boolean,
        modoBalcao: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            buscouCep: false,
            jaEscolheuBairroDaLista: false, // usado para validar que o bairro foi escolhido da lista e nao digitado
            cepNaoEncontrado: false,
            nome: this.$store.state.nomeCliente??'',
            rua: "",
            numero: "",
            cep: "", 
            bairro: "",
            bairroDoViaCep: "",
            complemento: "",
            cpf: this.$store.state.cpfCliente??'',
            cidade: "",
            uf: "",
            enderecoAnterior: this.$store.state.deliveryEndereco,
            bairrosAllFood: this.$store.state.lista_bairros,
            aceitaRetirada: this.$store.state.deliveryAceitaRetirada,
            aceitaEntrega: this.$store.state.deliveryAceitaEntrega,
            retirarNoLocal: this.$store.state.deliveryRetirarNoLocal,
        }
    },

    created() {
        this.inicializarModoEntregaRetirada()
        this.setarDadosEnderecoAntigo()
    },

    watch: {
        usarEnderecoAntigo() {
            this.setarDadosEnderecoAntigo()
        },
    },
    computed: {
        validou() {
            if (this.nome == "" && this.exigirNome) {
                return false
            }
            if (this.cpf == "" && this.exigirNome) {
                return false
            }
            if (!this.validouCpf() && this.exigirNome) {
                return false
            }
            if(!this.retirarNoLocal&&!this.modoBalcao){
                if (this.rua == "") {
                    return false
                }
                if (this.numero == "") {
                    return false
                }
                if (this.bairro == "") {
                    return false
                }
                if (this.jaEscolheuBairroDaLista == false) {
                    return false
                }
                if (this.cidade == "") {
                    return false
                }
                if (this.uf == "") {
                    return false
                }
            }
            return true   
        }
    },

    methods: {
        inicializarModoEntregaRetirada() {
            if(this.aceitaEntrega){
                this.selecionarEntregaNoLocal(false)
                return
            }
            if (this.aceitaRetirada) {
                this.selecionarEntregaNoLocal(true)
                return
            }
        },

        selecionarEntregaNoLocal(selecionouRetirarNoLocal) {
            this.retirarNoLocal = selecionouRetirarNoLocal
            this.$store.dispatch('setDeliveryRetirarNoLocal', selecionouRetirarNoLocal)
        },

        setarDadosEnderecoAntigo() {
            if (this.usarEnderecoAntigo) {
                let enderecoAntigo = this.$store.state.deliveryEndereco
                this.rua = enderecoAntigo?.rua
                this.numero = enderecoAntigo?.numero
                this.cep = enderecoAntigo?.cep
                this.bairro = enderecoAntigo?.bairro
                this.bairroDoViaCep = enderecoAntigo?.bairro
                this.complemento = enderecoAntigo?.complemento ?? ""
                this.cidade = enderecoAntigo?.cidade
                this.uf = enderecoAntigo?.uf
                this.buscouCep = true
                this.jaEscolheuBairroDaLista = true
            } else {
                this.rua = null
                this.numero = null
                this.cep = null
                this.bairro = null
                this.complemento = null
                this.cidade = this.$store.state.endereco.cidade ? this.$store.state.endereco.cidade : null
                this.uf = this.$store.state.endereco.uf ? this.$store.state.endereco.uf : null
                this.buscouCep = false
                this.jaEscolheuBairroDaLista = false
            }
        },

        enviarCep() {
            this.loading = true;
            ApiDelivery.buscarEnderecoPorCEP(this.cep)
                .then(endereco => {
                    this.rua = endereco.rua;
                    this.bairroDoViaCep = endereco.bairro;
                    this.cidade = endereco.cidade;
                    this.uf = endereco.uf;
                    this.loading = false;
                    this.buscouCep = true;
                })
                .catch(() => {
                    Swal.fire({title: "CEP nao encontrado"})
                    this.loading = false;
                    this.buscouCep = false;
                })
        },

        validouCpf() {
            return validadeCpf(this.cpf)
        },

        validouBairro(val) {
            this.jaEscolheuBairroDaLista = val
        },

        escolheuBairro(val) {
            this.bairro = val
        },

        gerarObjetoEndereco() {
            let dados = new EnderecoModel()
            dados.bairro = this.bairro
            dados.cep = this.cep ? this.cep : "00000-000"
            dados.cidade = this.cidade
            dados.complemento = this.complemento ?? ""
            dados.rua = this.rua
            dados.numero = this.numero
            dados.uf = this.uf
            dados.enderecoPrincipal = true
            return dados
        },

        validar() {
            if (this.nome == "" && this.exigirNome) {
                Swal.fire({title: "Por favor, preencha seu NOME"})
                return false
            }
            if (this.cpf == "" && this.exigirNome) {
                Swal.fire({title: "Por favor, preencha seu CPF"})
                return false
            }
            if (!this.validouCpf() && this.exigirNome) {
                Swal.fire({title: "CPF invalido. Por favor, insira um CPF valido"})
                return false
            }
            if(!this.retirarNoLocal && !this.modoBalcao){
                if (this.rua == "") {
                Swal.fire({title: "Por favor, preencha o nome da RUA"})
                return false
                }
                if (this.numero == "" || this.numero == null || this.numero.length == 0) {
                    Swal.fire({title: "Por favor, preencha o NUMERO do seu endereco"})
                    return false
                }
                if (this.bairro == "") {
                    Swal.fire({title: "Por favor, preencha o BAIRRO"})
                    return false
                }
                if (this.jaEscolheuBairroDaLista == false) {
                    Swal.fire({title: "Por favor, escolha um bairro da lista"})
                    return false
                }
                if (this.cidade == "") {
                    Swal.fire({title: "Por favor, preencha a CIDADE"})
                    return false
                }
                if (this.uf == "") {
                    Swal.fire({title: "Por favor, preencha o ESTADO (UF)"})
                    return false
                }
            }
            return true   
        
        },

        async salvar() {
            if (this.validar()) {
                
                this.loading = true

                this.$store.dispatch('setCpfCliente',this.cpf);
                this.$store.dispatch('setNomeCliente', this.nome);
                if (!this.modoBalcao && !this.retirarNoLocal) {
                    const endereco = this.gerarObjetoEndereco()
                    /** se o andereco antigo for nulo, entao estamos adicionando um endereco e cliente */
                    if (this.usarEnderecoAntigo == false) {
                        console.log("adicionando endereco");
                        let cliente = await ApiDelivery.adicionarCliente(this.$store.state.cnpj, this.telefoneCliente, this.nome, this.cpf)
                        await ApiDelivery.adicionarEndereco(cliente.Id, endereco)
                    } 
                    /** Se o endereco antigo nao for nulo, entao estamos atualizando ele */
                    else {
                        console.log("ATUALIZANDO endereco");
                        // console.log(endereco.id)
                        console.log(this.$store.state.deliveryEndereco.id)
                        endereco.id = this.$store.state.deliveryEndereco.id
                        await ApiDelivery.atualizarEndereco(this.$store.state.deliveryEndereco.id, endereco);
                    }
                    console.log(endereco)
                    console.log("^--------------------------")
                    /** setar no state o novo endereco */
                    this.$store.dispatch('setDeliveryEndereco', endereco)
                } else {
                    // Para balcão, só adicionar cliente se não existir
                    // if (this.usarEnderecoAntigo == false) {
                    let cliente = await ApiDelivery.adicionarCliente(this.$store.state.cnpj, this.telefoneCliente, this.nome, this.cpf)
                    console.log("Cliente adicionado para balcão ou retirada no local:", cliente);
                    // }
                }
                this.$emit("onFinished")
            }

            // this.loading = true
            // this.$store.dispatch('setCpfCliente', this.cpf)
            // this.$store.dispatch('setNomeCliente', this.nome)
            // try {
            //     if (this.retirarNoLocal) {
            //         if (this.usarEnderecoAntigo == false) {
            //             await ApiDelivery.adicionarCliente(this.$store.state.cnpj, this.telefoneCliente, this.nome, this.cpf)
            //         }
            //         this.$emit("onFinished")
            //         return
            //     }
            //     const endereco = this.gerarObjetoEndereco()
            //     console.log("this.usarEnderecoAntigo")
            //     console.log(this.usarEnderecoAntigo)
            //     console.log("endereco")
            //     console.log(endereco)
            //     if (this.usarEnderecoAntigo == false ) {
            //         let cliente = await ApiDelivery.adicionarCliente(this.$store.state.cnpj, this.telefoneCliente, this.nome, this.cpf)
            //         await ApiDelivery.adicionarEndereco(cliente.Id, endereco)
            //     } else {
            //         endereco.id = this.$store.state.deliveryEndereco.id
            //         await ApiDelivery.atualizarEndereco(this.$store.state.deliveryEndereco.id, endereco)
            //     }

            //     this.$store.dispatch('setDeliveryEndereco', endereco)
            //     this.$emit("onFinished")
            // } finally {
            //     this.loading = false
            // }
        },
    }
}
</script>

<style scoped>
.input-btn {
    width: 100%;
}

.input-btn * {
    width: 100%;
    margin: 0;
    padding: 0;
}

.btn-normal {
    margin-top: var(--padding-padrao);
    color: var(--cor-texto);
}

.btn-entregar-retirar {
    min-height: 50px;
    color: var(--cor-texto);
    padding: 10px;
    padding-inline: 10px;
    flex: 1;
    border-radius: 4px;
}

.btn-entregar-retirar-selecionado {
    min-height: 50px;
    background: var(--cor2);
    color: white;
    padding: 10px;
    padding-inline: 10px;
    flex: 1;
    border-radius: 4px;
}
</style>
